/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $AreaOfInterest = {
    properties: {
        key: {
            type: 'string',
            isRequired: true,
        },
        id: {
            type: 'number',
            isRequired: true,
        },
        name: {
            type: 'Translation',
            isRequired: true,
        },
        display: {
            type: 'boolean',
            isRequired: true,
        },
        regionId: {
            type: 'number',
            isRequired: true,
        },
        proDisabled: {
            type: 'boolean',
            isRequired: true,
        },
        pro4All: {
            type: 'boolean',
            isRequired: true,
        },
        programmaticAdsActive: {
            type: 'boolean',
        },
    },
} as const;
